export enum NewIds {
  StringID = 'NEW',
  NumberID = -1,
}

export interface StringIdModel {
  id: string | NewIds.StringID;
}

export interface NumberIdModel {
  id: number | NewIds.NumberID;
}

export type IdModel = StringIdModel | NumberIdModel;
